import { render, staticRenderFns } from "./price-common.vue?vue&type=template&id=4b87246e&scoped=true&"
import script from "./price-common.vue?vue&type=script&lang=js&"
export * from "./price-common.vue?vue&type=script&lang=js&"
import style0 from "./price-common.vue?vue&type=style&index=0&id=4b87246e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b87246e",
  null
  
)

export default component.exports